import store from '@/store';
import {customerHomePath, resolveStoreAccess} from '@/utils/access-context';
import WorkspaceLayout from '@/views/layout/workspace';
import WorkspaceNotFoundPage from '@/views/pages/workspace/error/not-found';
import {workspaceRouteMeta} from '@/views/routes/route-meta';
import {workspaceAdminRoutes} from '@/views/routes/workspace-admin-routes';
import {workspacePrimaryRoutes} from '@/views/routes/workspace-primary-routes';

export const workspaceRoutes = [
    {
        path: '/workspace',
        component: WorkspaceLayout,
        redirect: () => customerHomePath(resolveStoreAccess(store)),
        meta: workspaceRouteMeta(),
        children: [
            ...workspacePrimaryRoutes,
            ...workspaceAdminRoutes,
            {path: ':pathMatch(.*)*', component: WorkspaceNotFoundPage, meta: workspaceRouteMeta()},
        ],
    },
];

export const workspaceLegacyRoutes = [
    {
        path: '/dashboard',
        redirect: () => customerHomePath(resolveStoreAccess(store)),
    },
    {
        path: '/dashboard/:pathMatch(.*)*',
        redirect: (to) => '/workspace/' + String(to.params.pathMatch || ''),
    },
];
